<ng-template #header>
    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-schedule__sub-h">
        SCHEDULED ORDER
    </shared-header>

    <shared-header [center]="true" class="modal-for-schedule__h" type="3" marginTop="none" marginBottom="none">
        When do you want to order?
    </shared-header>

    <shared-text class="modal-for-schedule__desc" [brandAccent]="false" [dimmed]="true" weight="300">
        Select from the available days & times below
    </shared-text>

</ng-template>

<shared-modal-type-dynamic-height [minHeight]="55" [header]="header" [footer]="footer" [headerBorderBottom]="false"
    [modalData]="modalData" [center]="true" [footerBorder]="true" [mobilePreserve]="true" [size]="size"
    (onScrollInit)="handleScrollInit($event)" (onCloseClick)="handleCloseClick($event)" class="modal-for-schedule">

    <div class="modal-for-schedule__form">
        <shared-forms-input *ngIf="(collectionTypesLinks$ | async)?.length > 1"
            [defaultSelected]="(selectedCollectionType$ | async)?.Id" type="select"
            [selectOptions]="collectionTypesLinks$ | async" (onSelectChange)="handleCollectionTypeChange($event)">
        </shared-forms-input>

        <shared-pickup-for-schedule-mock [hidden]="!isDineInSelected"></shared-pickup-for-schedule-mock>

        <shared-pickup-for-schedule [hidden]="isDineInSelected" [disabled]="isDineInSelected" [modalId]="modalData.id"
            (onPickupSelected)="handlePickupSelected($event)" (onFormInit)="handleFormInit($event)"
            [locationNo]="modalData.locationNo" [update]="modalData?.params?.update">
        </shared-pickup-for-schedule>
    </div>

</shared-modal-type-dynamic-height>



<ng-template #footer>
    <div class="modal-for-schedule__ft">
        <shared-btn size="xlg" width="extended" type="button" [emphasis]="false" (onClick)="handleAccept($event)"
            [disabled]="!isFormValid">
            {{buttonDynamicLabel}}
        </shared-btn>
    </div>
</ng-template>
